import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Page from '../../../components/Page';
import MyJobList from './MyJobList'
import { Paper } from '@material-ui/core';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function MyJob() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
   <Page
     title="My Job"
   >
     <div className={classes.root}>
       <Paper position="static">
         <Tabs value={value} onChange={handleChange} aria-label="Job Board" centered>
           <Tab label="Posted" {...a11yProps(0)} />
           <Tab label="requested" {...a11yProps(1)} />
           <Tab label="Accepted" {...a11yProps(2)} />
           <Tab label="Done" {...a11yProps(3)} />
           <Tab label="Approved" {...a11yProps(4)} />


         </Tabs>
       </Paper>
       <TabPanel value={value} index={0}>
         <MyJobList type="posted"></MyJobList>
       </TabPanel>
       <TabPanel value={value} index={1}>
         <MyJobList type="requested"></MyJobList>
       </TabPanel>
       <TabPanel value={value} index={2}>
         <MyJobList type="accepted"></MyJobList>
       </TabPanel>
       <TabPanel value={value} index={3}>
         <MyJobList type="done"></MyJobList>
       </TabPanel>
       <TabPanel value={value} index={4}>
         <MyJobList type="approved"></MyJobList>
       </TabPanel>
     </div>
   </Page>
  );
}